import VueRouter from 'vue-router'

export default new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: () => import('./components/Home.vue')
        },
        {
            name: 'student',
            path: '/payment/:semester',
            component: () => import('./components/StudentLogin.vue')
        },
        {
            name: 'tuitionbalance',
            path: '/tuition/balance',
            component: () => import('./components/Balance.vue')
        },
        {
            name: 'graduationfee',
            path: '/graduationfee/pay',
            component: () => import('./components/GraduationFee.vue')
        },
        {
            name: 'login',
            path: '/login',
            component: () => import('./components/Login.vue')
        },
        {
            path: '/test',
            component: () => import('./components/PayFee.vue')
        },
        {
            name: 'paymentgateway',
            path: '/student/fee',
            component: () => import('./components/Fee.vue')
        },
        {
            name: 'squaretest',
            path: '/squaretest',
            component: () => import('./components/SquareUp.vue')
        },
        {
            name: 'googlesheet',
            path: '/applynow',
            component: () => import('./components/Sheet.vue')
        },
        {
            name: 'support',
            path: '/support/ticket/create',
            component: () => import('./components/zoho/CreateTicket.vue')
        }
    ]
})